import { IDropdown } from '@app/shared/interfaces/dropdown';

export enum MENTAL_HEALTH_PREFERENCES {
  'Medication' = 1,
  'Facilities' = 2,
  'Care team' = 3,
  'Other' = 4,
}

export const MENTAL_HEALTH_PREFERENCES_DROPDOWN: IDropdown<string>[] = Object.values(MENTAL_HEALTH_PREFERENCES)
  .filter((value) => isNaN(Number(value)) === true)
  .map((value) => ({ value: `${MENTAL_HEALTH_PREFERENCES[value]}`, label: value } as IDropdown<string>));
